function downloadFileFromHref(fileName: string, href: string, dataTaktId: string) {
  const win = document.defaultView || window;

  if (!win) {
    return;
  }

  const element = document.createElement('a');
  element.setAttribute('href', href);
  element.setAttribute('download', fileName);
  element.setAttribute('data-takt-id', dataTaktId);
  element.style.display = 'none';
  document.body.appendChild(element);

  element.dispatchEvent(
    new MouseEvent('click', {
      bubbles: false,
      cancelable: true,
      view: win,
    }),
  );

  document.body.removeChild(element);
}

export default downloadFileFromHref;
